module.exports = __webpack_public_path__ + "img/menu-button-wide.fb61ae00.svg";